
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import {
  LegalSectionData,
  LegalSectionMethods,
  LegalSectionComputed,
  LegalSectionProps,
} from './LegalSection';
import GenericImage from '@owc-packages/GenericImage/src/GenericImage.vue';
import { componentMode } from './Footer.config';
/**
 * `Legal Section Footer` - Legal Section Footer for OneWeb - Legal Section contains the legal information of the website, this components exists inside the Lower Footer Component
 */

export default ComponentInitializeDispatcher.extend<
  LegalSectionData,
  LegalSectionMethods,
  LegalSectionComputed,
  LegalSectionProps
>({
  name: 'owc-legal-section',
  components: {
    GenericImage,
  },
  props: {
    legalSection: {
      type: Object,
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.qrCodeImage) {
        this.sendMessageToParentContainer();
      }
    });
  },
  computed: {
    isEdit: function(): boolean {
      return componentMode.isEditMode;
    },
    legalItems: function() {
      return this.isEdit ? this.componentData?.items : this.legalSection?.items;
    },
    legalLicense: function() {
      return this.isEdit ? this.componentData?.license : this.legalSection?.license;
    },
    qrCodeData: function() {
      return this.isEdit ? this.componentData?.qrCode : this.legalSection?.qrCode;
    },
    qrCodeImage: function() {
      return this.qrCodeData?.source;
    },
  },
  methods: {
    sendMessageToParentContainer: function() {
      this.$el.dispatchEvent(
        new CustomEvent('qrCodeActive', {
          composed: true,
          bubbles: true,
        }),
      );
    },
  },
});
